import * as React from 'react';

import type { SupplierHistoryClient } from '@/api/supplier-history-client';
import { HttpSupplierHistoryClient } from '@/api/supplier-history-client.http';

// =============================================================================
// supplier-history-client-context.tsx — Injection du SupplierHistoryClient (DI seam, Lot A, DBU §3.9).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut : l'adaptateur HTTP RÉEL
// (HttpSupplierHistoryClient) — le BACK historique fournisseur est livré (Lot A). Câblé HTTP DÈS LE DÉPART
// (garde 09_stub_in_prod_guard : aucun défaut stub-en-prod). Les tests de composant injectent un
// StubSupplierHistoryClient (double déterministe) via le provider.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session fournisseur). */
const defaultSupplierHistoryClient: SupplierHistoryClient =
  new HttpSupplierHistoryClient();

const SupplierHistoryClientContext =
  React.createContext<SupplierHistoryClient>(defaultSupplierHistoryClient);

export interface SupplierHistoryClientProviderProps {
  client?: SupplierHistoryClient | undefined;
  children: React.ReactNode;
}

export function SupplierHistoryClientProvider({
  client = defaultSupplierHistoryClient,
  children,
}: SupplierHistoryClientProviderProps): React.JSX.Element {
  return (
    <SupplierHistoryClientContext.Provider value={client}>
      {children}
    </SupplierHistoryClientContext.Provider>
  );
}

export function useSupplierHistoryClient(): SupplierHistoryClient {
  return React.useContext(SupplierHistoryClientContext);
}
